import React from "react";
import { Label } from "../../../components/Inputs";
import {
  SimpleTextEditor,
  ImageEditor,
} from "../../../components/RichTextEditor";
import HtmlText from "../../../components/HtmlText";

export const buildSignature = ({ text, image }) => `
  <table style="width:fit-content">
    <tbody>
      <tr>
        <td style="vertical-align:top;">
          ${image}
        </td>
        <td style="vertical-align:top;padding-left:16px">
          ${text.split("<p>").join(`<p style="margin-block:0.2em">`)}
        </td>
      </tr>
    </tbody>
  </table>
`;

const SignatureForm = React.forwardRef(function SignatureForm(
  { className = "", model = { text: "", image: "" } },
  ref,
) {
  const [text, setText] = React.useState(model.text);
  const [image, setImage] = React.useState(model.image);
  const [error, setError] = React.useState({ text: null });

  const validate = (noValidate, noUpdate) => {
    const m = { text, image };
    // check if all values are set
    const newError = { ...error };
    let isValid = true;
    Object.keys(m).forEach((key) => {
      if (!noValidate && newError[key] !== undefined) {
        const test = m[key] === "";
        if (test) {
          newError[key] = true;
          isValid = false;
        } else {
          newError[key] = null;
        }
      }
    });
    if (!isValid) {
      if (!noUpdate) setError(newError);
      return null;
    }
    m.name = model.name;
    return m;
  };

  React.useImperativeHandle(ref, () => ({
    getModel: (noValidate, noUpdate) => validate(noValidate, noUpdate),
  }));

  return (
    <div className={`${className} pos-rel`}>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "12px",
        }}
      >
        <div>
          <Label htmlFor="image">{`Bild/Logo`}</Label>
          <ImageEditor
            id="image"
            className="w3-white"
            value={image}
            onChange={(event) => setImage(event.target.value)}
            rows={10}
          />
        </div>
        <div style={{ flexGrow: 1 }}>
          <Label htmlFor="text">{`Text`}</Label>
          <SimpleTextEditor
            id="text"
            className="w3-white"
            value={text}
            onChange={(event) => {
              setText(event.target.value);
              setError((prev) => ({
                ...prev,
                text: event.target.value === "",
              }));
            }}
            showFonts
            rows={10}
          />
        </div>
      </div>
      <div className="margin-tb pad bold alg-center w3-light-grey">
        {"Vorshau"}
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <HtmlText text={buildSignature({ text, image })} />
      </div>
    </div>
  );
});

export default SignatureForm;
